export default function mobileMenu(){
  const toggleMenu = () => {
    $('.menu-main-menu-container').slideToggle()
  }

  $('.menu-trigger').click(function(){
    $(this).toggleClass('active')
    toggleMenu()
  })
}